import { CasesService } from './../../../app-cases/services/cases.service';
import { fromEvent, merge, Observable, of, Subject } from 'rxjs';
import {
    Component,
    ComponentFactoryResolver,
    Inject,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
    ElementRef,
    Renderer2
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {
    FuseConfigService,
    FuseSidebarService,
    TemplateAtlasSharedService
} from '../../../shared/standalone-packages/ecap3/template-atlas';
import {
    EcapCoreAnalyticsService,
    EcapLoginService,
    EcapTranslateService,
    getCurrentLanguage as GetCurrentLanguage,
    NavigationProvider,
    ShellDomainProvider,
    State,
    UserInfoService
} from '../../../shared/standalone-packages/ecap3/core';
import { MatDialog } from '@angular/material/dialog';
import { routes } from '../../routes';
import { navigations } from '../../navigations';
import { mapTo, takeUntil } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';
import { SCPCXToolbarComponent } from '../../fuse/toolbar/toolbar.component';
import { Store } from '@ngrx/store';
import { UpdateService } from '../../service/updateSw';
import { TitleService } from '../../service/title.service';
import { FuseAboutComponentDynamicComponent } from '../../fuse/about-dynamic/about.component';
import { PcxNavbarComponent } from '../../fuse/pcx-navbar/pcx-navbar.component';
import { CommonService } from '../../../shared/services/common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StoreDataService } from '../../../shared/services/store-data.service';
import { BusinessService } from '../../../shared/services/business.service';
import { IpexUserInformationService } from '../../../shared/services/ipex-user-information.service';
import { SideBarNavigationService } from '../../../shared/services/side-bar-navigation.service';
import { AppMailboxService } from '../../../app-mail-box/services/app-mailbox.service';
import { DialogConfirmComponent } from '../../../shared/components/dialog-confirm/dialog-confirm.component';
// import { DialogAlertComponent } from '../../../shared/components/dialog-alert/dialog-confirm/dialog-alert.component';

@Component({
    selector: 'app-root-default',
    templateUrl: './root-default.component.html',
    styleUrls: ['./root-default.component.scss'],
    standalone: false
})
export class RootDefaultComponent implements OnInit, OnDestroy {
    TenantLogo: string = ShellDomainProvider['api']['CdnTenantBaseUrl'] + 'images/ipex_logo.svg';
    apps: any[];
    navigations: any[];
    routeData: any;
    public toolbarComponent: any;
    dialogRef: any;
    language = new Subject<string>();
    lang$: Observable<string>;
    isPlatformServer: any;
    userSelectedFeatures: any;
    prevUrl: string = '';
    online$: Observable<boolean>;
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private router: Router,
        public dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private fuseConfig: FuseConfigService,
        private matSnackBar: MatSnackBar,
        private ecapTranslateService: EcapTranslateService,
        private templateAtlasSharedService: TemplateAtlasSharedService,
        private navigationProvider: NavigationProvider,
        private cfr: ComponentFactoryResolver,
        private swUpdateService: UpdateService,
        private titleService: TitleService,
        private loginService: EcapLoginService,
        @Inject(PLATFORM_ID) platformId: Object,
        private ecapCoreAnalyticsService: EcapCoreAnalyticsService,
        private store: Store<State>,
        private _fuseSidebarService: FuseSidebarService,
        private commonService: CommonService,
        private casesService: CasesService,
        private userInfoService: UserInfoService,
        private mailboxService: AppMailboxService,
        private el: ElementRef,
        private renderer: Renderer2,
        private storeDataService: StoreDataService,
        private ipexUserInformationService: IpexUserInformationService,
        private sideBarNavigationService: SideBarNavigationService,
        private businessService: BusinessService
    ) {
        router.initialNavigation();
        this.ipexUserInformationService.getCurrentLoggedInUserInformation().subscribe();

        this.ecapCoreAnalyticsService.initializeAnalytics();
        this.isPlatformServer = isPlatformServer(platformId);
        this.navigationProvider.setCurrentNavigations(navigations);
        this.ecapTranslateService.initLang();
        this.lang$ = this.store.select(GetCurrentLanguage);
        this.swUpdateService.subscribeForAutomaticVersionUpdate();
        this.apps = routes;
        this.navigations = navigations;
        this.sideBarNavigationService.navigation$.subscribe(navigation => {
            this.navigations = navigation;
            this.navigationProvider.setCurrentNavigations(navigation);
        });

        this.router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.swUpdateService.checkForUpdates();
                let navbarStatus = true;
                this.getIpexUserInformation();
                const persistedFolded = localStorage.getItem('isFolded');
                if (persistedFolded !== null) {
                    navbarStatus = persistedFolded === 'true';
                } else if (
                    (event.id !== 1 || event.url !== event.urlAfterRedirects) &&
                    !(
                        this.prevUrl.includes('/login') ||
                        this.prevUrl.includes('/account') ||
                        event.url === '/' ||
                        this.prevUrl === ''
                    )
                ) {
                    const navbar = this._fuseSidebarService.getSidebar('navbar');
                    if (navbar) {
                        navbarStatus = navbar.folded;
                    }
                }
                if (
                    this.prevUrl.includes('/login') ||
                    this.prevUrl === '' ||
                    (this.isInsideApp(event.url) && event.id === 1)
                ) {
                    this.userInfoService
                        .getLoggedInUser()
                        .pipe(takeUntil(this.destroy$))
                        .subscribe(user => {
                            this.commonService.AssignedCaseWithInspector();
                            this.commonService.changedUserRole();
                            // this.commonService.changedClearingUserRole();
                        });
                }
                this.prevUrl = event.urlAfterRedirects;
                if (event.url === '/login' || event.url === '/') {
                    this.prevUrl = '';
                }

                if (
                    event.url.includes('/login') ||
                    event.url === '/' ||
                    event.url.includes('/404') ||
                    event.urlAfterRedirects.includes('/404') ||
                    event.urlAfterRedirects.includes('/login')
                ) {
                    this.casesService.getAdditionalSearchFilterData();
                } else if (!CasesService.hasAdditionalSearchFilterData) {
                    this.userInfoService
                        .getLoggedInUser()
                        .pipe(takeUntil(this.destroy$))
                        .subscribe(user => {
                            this.casesService.getAdditionalSearchFilterData(user);
                        });
                }
                const currentApp = this.activatedRoute.root.firstChild.snapshot; // Need to better approch for get current route
                const hideTemplateNavigations = currentApp && currentApp.data ? currentApp.data['isFullScreen'] : true;
                if (!hideTemplateNavigations) {
                    this.fuseConfig.setConfig({
                        colorTheme: 'theme-ecap',
                        customScrollbars: true,
                        layout: {
                            style: 'vertical-layout-1',
                            width: 'fullwidth',
                            navbar: {
                                primaryBackground: 'nav-primaryBackground',
                                // background: 'mat-arc-primary-50-bg',

                                folded: navbarStatus,
                                hidden: false,
                                userNameShow: false,
                                designationShow: false,
                                position: 'left',
                                // variant: 'vertical-style-2',
                                variant: 'vertical-style-dynamic',
                                dynamicVarientComponent: this.cfr.resolveComponentFactory(PcxNavbarComponent),
                                navbarTop: 'spp-nav-tool',
                                laftNavigationTopLogo:
                                    ShellDomainProvider['api'] &&
                                    ShellDomainProvider['api']['CdnTenantBaseUrl'] + 'images/ipex_logo.svg',
                                topMenu: {
                                    showMyAccount: false,
                                    showAbout: false,
                                    showMemory: false,
                                    showLogout: false,
                                    logoutIcon: 'exit_to_app'
                                }
                            },
                            toolbar: {
                                logo:
                                    ShellDomainProvider['api'] &&
                                    ShellDomainProvider['api']['CdnTenantBaseUrl'] + 'images/ipex_logo.svg',
                                background: 'mat-arc-primary-bg',
                                customBackgroundColor: true,
                                hidden: false,
                                position: 'below-fixed',
                                component: {
                                    shortcuts: false,
                                    search: false,
                                    userInfo: true,
                                    sudebar: true
                                },
                                breadcrumb: false
                            },
                            footer: {
                                background: 'mat-grey-A100-bg',
                                hidden: true,
                                position: 'below-static'
                            },
                            sidepanel: {
                                hidden: true,
                                position: 'right'
                            },
                            floatingChatPanelConfig: {
                                admin: {
                                    showChatPanel: true,
                                    onlyNotification: true
                                }
                            },
                            notificationQueryPayload: {
                                ResponseKeys: ['MessagingThreadNotification'],
                                ResponseKeyFilterOperator: 'NotIn',
                                OnlyUnread: false,
                                OrderByCreatedDate: 1,
                                ReturnCount: true,
                                PageNumber: 1,
                                PageSize: 100
                            },
                            onlyMessageQueryPayload: {
                                ResponseKeys: ['MessagingThreadNotification'],
                                ResponseKeyFilterOperator: 'In',
                                OnlyUnread: true,
                                OrderByCreatedDate: 1,
                                ReturnCount: true,
                                PageNumber: 1,
                                PageSize: 100
                            },
                            breadcrumb: false
                        },
                        app: {
                            login: {
                                loginformTopLogo:
                                    'https://az-cdn.selise.biz/selisecdn/cdn/swisspartners/Logo/logo_login_256.png'
                            }
                        }
                    });
                } else {
                    this.fuseConfig.resetToDefaults();
                }
            }
        });
    }
    logOut = () => {
        console.warn('Logout triggered: RootDefaultComponent.logOut() called.');
        this.loginService.logoutFromPlatform();
        localStorage.removeItem('logged-in-this-platform');
    };
    resolveComp() {
        this.toolbarComponent = this.cfr.resolveComponentFactory(SCPCXToolbarComponent);
    }

    ngOnInit(): void {
        this.titleService.init();
        this.resolveComp();
        if (!this.isPlatformServer) {
            this.online$ = merge(
                of(navigator.onLine),
                fromEvent(window, 'online').pipe(mapTo(true)),
                fromEvent(window, 'offline').pipe(mapTo(false))
            );
            this.online$.pipe(takeUntil(this.destroy$)).subscribe(response => {
                if (!response) {
                    const message = this.ecapTranslateService.instantTranslate('INTERNET_UNAVAILABLE');
                    this.matSnackBar.open(message);
                } else {
                    this.matSnackBar.dismiss();
                }
            });
        }

        // ========================================================
        // setting configuration for entitybased chat directive
        // According to this entitybasedChat directive will take
        // decision how it will open chat box
        // ========================================================

        this.templateAtlasSharedService.openAboutModal.pipe(takeUntil(this.destroy$)).subscribe(result => {
            if (result) {
                this.dialogRef = this.dialog.open(FuseAboutComponentDynamicComponent, {
                    width: '720px',
                    maxWidth: '100vw',
                    panelClass: 'custom-dialog'
                });

                this.dialogRef
                    .afterClosed()
                    .pipe(takeUntil(this.destroy$))
                    .subscribe(clo => { });
            }
        });
        this.sideBarNavigationService.initSubscriptions(this.el, this.renderer);
    }

    public openMyAccountModal = () => {
        this.router.navigate(['/profile']);
    };

    public goMyAboutPage = () => {
        this.dialogRef = this.dialog.open(FuseAboutComponentDynamicComponent, {
            width: '720px',
            maxWidth: '100vw',
            panelClass: 'custom-dialog'
        });

        this.dialogRef
            .afterClosed()
            .pipe(takeUntil(this.destroy$))
            .subscribe(result => { });
    };

    public getCurrentApp(url) {
        for (let index = 0; index < this.apps.length; index++) {
            if (this.apps[index].path === url.split('?')[0].slice(1)) {
                return this.apps[index];
            }
        }
        return;
    }

    public isInsideApp(routeUrl: string) {
        const routesAfterLogin = ['/mailbox', '/users', '/cases'];
        let res = false;
        routesAfterLogin.forEach(item => {
            if (routeUrl.includes(item)) {
                res = true;
                return res;
            }
            return false;
        });
        return res;
    }

    public getIpexUserInformation() {
        this.userInfoService
            .getLoggedInUser()
            .pipe(takeUntil(this.destroy$))
            .subscribe(user => {
                this.ipexUserInformationService.getIpexUserInformation([user.UserId]).subscribe(res => {
                    if (res && res.Results.length > 0) {
                        let userInfo: any = res.Results[0];
                        if (userInfo.IsLoginRequired) {
                            this.dialog
                                .open(DialogConfirmComponent, {
                                    disableClose: true,
                                    data: {
                                        HeaderText: 'ROLE_CHANGED_HEADER',
                                        BodyText: 'ROLE_CHANGE_MODAL_BODY_TEXT',
                                        ButtonNoText: null,
                                        ButtonYesText: 'YES'
                                    },
                                    autoFocus: false
                                })
                                .afterClosed()
                                .pipe(takeUntil(this.destroy$))
                                .subscribe(res => {
                                    if (res) {
                                        this.updateLoginStatus();
                                    }
                                });
                        }
                    }
                });
            });
    }

    public updateLoginStatus(): void {
        this.userInfoService.getLoggedInUser().subscribe(res => {
            if (res) {
                const payload = {
                    UserId: res.UserId
                };
                this.businessService.updateLoginStatus(payload).subscribe(() => {
                    console.warn('Logout triggered: RootDefaultComponent.updateLoginStatus() response received.');
                    this.commonService.logout();
                });
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}